import type { ReactNode } from 'react';
import { Platform } from 'react-native';
import { StyleSheet } from 'react-native-unistyles';
import Avatar from '@/components/Custom/Avatar';
import PressableRow from '@/components/UI/PressableRow';
import Text from '@/components/UI/Text';
import Box from '@/components/Unistyles/Box';

export default function PeopleListItem({
  actions,
  avatarId,
  color,
  details,
  metadata,
  name,
  onPress,
  personTestID,
  selected,
  selection,
  testID,
}: {
  actions: ReactNode;
  avatarId: string;
  color: string;
  details: ReactNode;
  metadata: ReactNode;
  name: string;
  onPress: () => void;
  personTestID: string;
  selected: boolean;
  selection: ReactNode;
  testID: string;
}) {
  return (
    <PressableRow
      role={Platform.OS === 'web' ? undefined : 'button'}
      accessibilityState={{ selected }}
      onPress={onPress}
      style={[styles.row, selected && styles.selected]}
      testID={testID}
    >
      {selection}
      <Box style={styles.person} testID={personTestID}>
        <Avatar id={avatarId} color={color} name={name} size="md" />
        <Box flex minWidth={0} space="xs" style={styles.identity}>
          <Text size="md" bold>
            {name}
          </Text>
          {metadata}
          {details}
        </Box>
      </Box>
      {actions}
    </PressableRow>
  );
}

const styles = StyleSheet.create((theme) => ({
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 0,
    paddingHorizontal: theme.space('lg'),
    paddingVertical: 0,
    borderBottomColor: theme.colors.borderMuted,
    borderBottomWidth: StyleSheet.hairlineWidth,
  },
  person: {
    flex: 1,
    flexDirection: 'row',
    minWidth: 0,
    alignItems: 'center',
    paddingHorizontal: 0,
    paddingVertical: theme.space('lg'),
    gap: theme.space('lg'),
  },
  selected: {
    backgroundColor: theme.colors.background,
  },
  identity: {
    minHeight: theme.size(10),
    justifyContent: 'center',
  },
}));
